<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Yc3m7/tc-custom/9781610588126.jpg?1706382905007" alt="This image is the cover for the book SR-71"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">SR-71
      </h1>
      <p class="bookDescription body article font2">
        <b>A pictorial history of the legendary Lockheed spy plane, written by one of its pilots and “filled to the brim with information and revelation” (<i>Seattle Post Intelligencer</i> Travel for Aircraft blog).</b><br/><br/>At the height of the Cold War in 1964, President Johnson announced a new aircraft dedicated to strategic reconnaissance. The Lockheed SR-71 Blackbird spy plane flew more than three-and-a-half times the speed of sound, so fast that no other aircraft could catch it. Above 80,000 feet, its pilots had to wear full-pressure flight suits similar to what was used aboard the space shuttle. Developed by the renowned Lockheed Skunk Works, the SR-71 was an awesome aircraft in every respect, and it took the world by storm. <br/><br/>The SR-71 was in service with the US Air Force from 1964 to 1998, when it was withdrawn from use, superseded by satellite technology. Twelve of the thirty-two aircraft were destroyed in accidents, but none were ever lost to enemy action. Throughout its thirty-four-year career, the SR-71 was the world’s fastest and highest-flying operational manned aircraft. It set world records for altitude and speed: an absolute altitude record of 85,069 feet on July 28, 1974, and an absolute speed record of 2,193.2 miles per hour on the same day. On September 1, 1974, it set a speed and time record over a recognized course between New York and London (3,508 miles) of 1,435.587 miles per hour and an elapsed time of 1 hour, 54 minutes, 56.4 seconds. <br/><br/><i>SR-71</i> covers every aspect of the plane’s development, manufacture, modification, and active service from the insider’s perspective of one its pilots—and is lavishly illustrated with more than 200 photos.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard H. Graham
      </h2>
      
      <p class="authorDescription body article">A veteran of fifteen years of assignments within the SR-71 community, Colonel Richard H. Graham is uniquely qualified to tell the Blackbird's story. Crew member, instructor pilot, chief of the standardization/evaluation division, Colonel Graham was named SR-71 Squadron Commander, 1st Strategic Reconnaissance Squadron, in January 1981. A command pilot with more than 4,600 military flying hours, he has earned military decorations and awards including the Legion of Merit, Distinguished Flying Cross with three oak leaf clusters, Air Medal with eighteen oak leaf clusters, Air Force Commendation Medal, Air Force Outstanding Unit Award with "V" device and one oak leaf cluster, Air Force Organizational Excellence Award, Combat Readiness Medal with one oak leaf cluster, National Defense Service Medal, Armed Forces Expeditionary Medal, Vietnam Service Medal with four service stars, Republic of Vietnam Gallantry Cross with palm, and the Republic of Vietnam Campaign Medal. Colonel Graham's books on the SR-71 include SR-71 Revealed: The Inside Story and SR-71 Blackbird: Stories, Tales and Legends. He lives in Plano, Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zenith Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55672cc0